import { render, staticRenderFns } from "./EditImage.vue?vue&type=template&id=f3f1d540&scoped=true&"
import script from "./EditImage.vue?vue&type=script&lang=ts&"
export * from "./EditImage.vue?vue&type=script&lang=ts&"
import style0 from "./EditImage.vue?vue&type=style&index=0&id=f3f1d540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f1d540",
  null
  
)

export default component.exports